import styled from 'styled-components';
import { layout, media, remCalc } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import UserReviewPromptComponent from '../../../reviews/components/prompt';
import { SUB_TITLE_SIZE } from '../../constants';

export const SotyPromo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${p => p.theme.promos.bg};
  color: ${p => p.theme.promos.fg};
  border-radius: 4px;
  padding: ${layout.measurements.spacing100};
  margin-top: ${layout.measurements.spacing100};

  ${media.mediumDown`
    margin: ${layout.measurements.spacing100};
  `}
`;

export const Title = styled.h4`
  font-size: ${remCalc(SUB_TITLE_SIZE)};
  text-align: center;
`;

export const Description = styled.p``;

export const Badge = styled.div`
  width: 120px;
`;

export const UserReviewPrompt = styled(UserReviewPromptComponent)`
  width: 100%;
`;

export const PromptButton = styled(Button)`
  font-weight: normal;
  text-transform: initial;
  width: 100%;
`;
